const DRAG_IMAGE_OFFSET = 16;

export const setComposerRowDragImage = (dataTransfer: DataTransfer, row: HTMLElement | null) => {
    if (!row) return;

    const bounds = row.getBoundingClientRect();
    const dragImage = row.cloneNode(true) as HTMLElement;

    Object.assign(dragImage.style, {
        position: 'fixed',
        top: '-10000px',
        left: '-10000px',
        width: `${bounds.width}px`,
        height: `${bounds.height}px`,
        margin: '0',
        opacity: '1',
        pointerEvents: 'none',
        zIndex: '-1'
    });

    document.body.appendChild(dragImage);
    dataTransfer.setDragImage(dragImage, Math.min(DRAG_IMAGE_OFFSET, bounds.width / 2), bounds.height / 2);
    window.setTimeout(() => dragImage.remove(), 0);
};
